import _ from 'lodash';
import dayjs from 'dayjs'
import { dataConstants } from 'services/redux/data/constants'

export const dateFormat = {
	DATE: 'YYYY-MM-DD',
	DATE_PRETTY: 'D MMMM YYYY',
	DATE_TIME: 'YYYY-MM-DD HH:mm:ss',

	SHORT_TIME: "HH:mm",
	FULL_TIME: "HH:mm:ss"
}

export const createDateHelper = ( getState ) => {
	const HelperDate = {

		ymd: ( date ) => {
			if( typeof date === 'undefined' ) {
				return HelperDate.date().format( dateFormat.DATE );
			}

			if( date.toString().includes('00:00:00') ) {
				return HelperDate.date( `${ date.getFullYear() }-${ date.getMonth() + 1 }-${ date.getDate() }`, undefined, true ).format( dateFormat.DATE );
			}

			return date.toISOString().split('T')[0]
		},

		split: ( date, add = true ) => {
			const dateSplit = date.split(':');

			// Amount
			const dateAmount = parseInt( dateSplit[ 1 ] );

			// Months, weeks, days
			let dateBy = dateSplit[ 0 ];
			if( !_.endsWith( dateBy, 's' ) ) {
				dateBy += 's';
			}

			// Create the date
			const dateObject = add ? HelperDate.date().add( dateAmount, dateBy ) : HelperDate.date().subtract( dateAmount, dateBy )

			return {
				date: dateObject,
				amount: dateAmount,
				by: dateBy
			}
		},

		compareDeviceWithServer: () => {
			const serverTime = getState().data[ dataConstants.SERVER_TIME ];

			//const currentTimezone = getState().data[ dataConstants.SERVER_TIMEZONE ] ?? 'Europe/Amsterdam'
			//const serverUtcOffset = getState().data[ dataConstants.SERVER_TIMEZONE_OFFSET ];

			return dayjs().utc().diff( dayjs.tz( serverTime ), 'second' )
		},

		prepareDate: date => {
			const serverUtcOffset = getState().data[ dataConstants.SERVER_TIMEZONE_OFFSET ];
			const serverTimeDifferenceSeconds = getState().data[ dataConstants.SERVER_TIME_DIFFERENCE_SECONDS ];

			const utc = dayjs.utc( date )
			const now = dayjs.utc()

			const utcUpdated = utc.set('hour', now.hour() ).set('minute', now.minute() ).set('second', now.second() )
			const utcOffset = utcUpdated[ serverUtcOffset >= 0 ?'add' : 'subtract' ]( serverUtcOffset, 'minute' )

			return utcOffset.subtract( serverTimeDifferenceSeconds, 'seconds' ).format( dateFormat.DATE_TIME )
			//return date + ` ${ utcOffset.format( 'HH:mm:ss' ) }`
		},

		time: ( time ) => {
			const timeSplit = time.split(':');

			return HelperDate.date().set('hour', timeSplit[0] ).set('minute', timeSplit[1] ).set('second', timeSplit[2] );
		},

		date: ( date = undefined, format = undefined, isModified = false ) => {

			// Do we need to prepare the date?
			let prepare = format === undefined;

			if( date instanceof Date ) {
				prepare = false;
				date = HelperDate.jsDate.transform( date )
			}

			if( typeof date === 'string' ) {
				if( isModified ||  _.startsWith( date, 'm:' ) ) {
					prepare = false;
					date = date.replace( 'm:', '' );
				}
			}

			if( prepare === true && typeof date === 'string' ) {
				//Check if the date has a time attached to it
				// Use the server offset to make sure it does not go back to the past
				if( !date.includes(':') ) {
					date = HelperDate.prepareDate( date )
				}
			}

			let dayjsObject = null;
			switch( true ) {
				case typeof date === 'undefined' && typeof format === 'undefined':
					dayjsObject = dayjs.utc( HelperDate.prepareDate( dayjs.utc().format('YYYY-MM-DD' ) ) )
					break;

				case typeof format === 'undefined':
					dayjsObject = dayjs.utc( date )
					break;

				default:
					// When time and no date is set? Then add the date to a full datetime
					if( format === dateFormat.FULL_TIME ) {
						if( typeof date === 'string' ) {

							// Check if the string has two ':' in it
							if( date.split(':').length === 2 ) {
								date += ':00'
							}

							if( !date.includes('-') ) {
								format = dateFormat.DATE_TIME
								date = HelperDate.date().format( dateFormat.DATE ) +' '+ date
							}
						}
					}

					dayjsObject = dayjs.utc( date, format )
					break;
			}

			if( dayjsObject === 'Invalid Date' ) {
				console.error('GOT INVALID DATE', date )
			}

			return dayjsObject
		},

		defaultDateRange: () => {
			return [
				HelperDate.date().subtract(1, 'weeks').startOf('week' ).toDate(),
				HelperDate.date().toDate()
			]
		},

		fn: {
			isToday: ( date ) => {
				if( _.isEmpty( date ) ) {
					return false;
				}

				return date.isSame( HelperDate.date(), 'day' )
			}
		},

		jsDate: {
			transform: ( date ) => {
				return HelperDate.date( `${ date.getFullYear() }-${ date.getMonth() + 1 }-${ date.getDate() }`, undefined, true )
			}
		}
	}

	return HelperDate;
}
